import { Tooltip, Box } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import { SweepTypographyVariants } from '@sweep-io/sweep-design/dist/components/Typography/types';
import { ReactNode } from 'react';
import { useOptimizedTextClamping } from './useOptimizedTextClamping';

interface ClampedTextProps {
  text: string | number | ReactNode;
  tooltip?: string; //if different than text, if not passed it's the same as text
  typographyVariant?: SweepTypographyVariants;
  endAdornment?: React.ReactNode;
  textColor?: string;
  disableHoverListener?: boolean;
  lines?: number;
}

export const ClampedText = ({
  text,
  tooltip,
  typographyVariant = 'body',
  endAdornment,
  textColor,
  disableHoverListener,
  lines = 2,
}: ClampedTextProps) => {
  const { ref, isClamped, isLoading } = useOptimizedTextClamping({
    debounceMs: 100, // Standard debounce for general text
  });

  return (
    <>
      {/* TODO SWEEP-4694 */}
      <Tooltip
        placement="bottom-start"
        title={tooltip ?? text}
        disableHoverListener={disableHoverListener ?? (!isClamped || isLoading)}
      >
        <Box overflow="hidden">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              minWidth: 0,
              //TODO add support in design system SWEEP-4335
              '& .MuiTypography-root': {
                display: '-webkit-box',
                WebkitLineClamp: lines,
                WebkitBoxOrient: 'vertical',
                whiteSpace: 'break-spaces',
                wordBreak: 'break-word',
                color: textColor ? textColor + ' !important' : colors.grey[900],
              },
            }}
            ref={ref}
          >
            <Typography
              color={textColor}
              whiteSpace="break-spaces"
              variant={typographyVariant}
              ellipsis={isClamped && !isLoading}
            >
              {text}
            </Typography>
            {endAdornment}
          </Box>
        </Box>
      </Tooltip>
    </>
  );
};
